<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue';
// biome-ignore lint/correctness/noUnusedImports: used via tag <KioskLayout> in <template>
import KioskLayout from '@/app/layouts/kiosk/KioskLayout.vue';
import exposeToGlobalScope from '@/shared/utils/expose-to-global-scope';
// biome-ignore lint/correctness/noUnusedImports: used via tag <PaymentTerminalView> in <template>
import PaymentTerminalView from './terminal/PaymentTerminalView.vue';
import {
  type PaymentTerminalFlow,
  usePaymentTerminalFlow,
} from './terminal/usePaymentTerminalFlow';

const {
  enter,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  errorCaptionKey,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  getTotalSumFormatted,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  isFinalPaymentError,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  isUnmounted,
  leave,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  onCancelClick,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  onExitSessionClick,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  onPopupContinueClick,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  onPopupExitClick,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  onRetryClick,
  publicApi,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  showTerminalCancelledPopup,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  state,
}: PaymentTerminalFlow = usePaymentTerminalFlow();

onMounted((): void => {
  enter((): void => exposeToGlobalScope(publicApi, 'PaymentTerminal'));
});

onBeforeUnmount(leave);

defineExpose(publicApi);
</script>

<template>
  <KioskLayout :is-centered="true">
    <PaymentTerminalView
      :error-caption-key="errorCaptionKey"
      :is-final="isFinalPaymentError"
      :show-cancelled-popup="showTerminalCancelledPopup && !isUnmounted"
      :state="state"
      :total="getTotalSumFormatted()"
      @cancel="onCancelClick"
      @exit-session="onExitSessionClick"
      @popup-continue="onPopupContinueClick"
      @popup-exit="onPopupExitClick"
      @retry="onRetryClick"
    />
  </KioskLayout>
</template>
